import { useMutation } from 'react-query';

import { useHttpClient } from '../../../../shared/http/HttpClientProvider';
import { MutationOptions, MutationResult } from '../../../../shared/types/query';
import { IActionUrlForm } from '../types/ActionUrl';
import { PAGE_KEY } from './index';

export function useCreateActionUrl(options?: MutationOptions<IActionUrlForm, IActionUrlForm>): MutationResult<IActionUrlForm, IActionUrlForm> {
  const http = useHttpClient();

  return useMutation({
    ...options,
    mutationKey: [`${PAGE_KEY}/create`],
    mutationFn: async (obj: IActionUrlForm) => {
      return http.request({
        method: 'post',
        url: 'ActionUrls',
        data: obj,
      }).then(result => result.data)
    },
  })
}